import { Buffer } from 'buffer'

const _global = globalThis

export { _global as global }

if ('TYPED_ARRAY_SUPPORT' in Buffer && Buffer.TYPED_ARRAY_SUPPORT) {
  const { isBuffer } = Buffer
  Buffer.isBuffer = (argument) => {
    return argument instanceof Uint8Array && isBuffer(argument)
  }
}

export { default as process } from 'process'

export { Buffer } from 'buffer'
